import { SectionWithVerticalSpacing } from '@insify/components';
import { LogoWithText } from '@insify/design-system/logo';
import { useBreakpoint } from '@insify/react-hooks';
import clsx from 'clsx';

import { RichContentWithTooltip } from '../../components/RichContent';
import { WizardLayoutForm } from '../../components/WizardLayoutForm';

import * as styles from './AlreadyApplied.module.css';

import type { RichContentType } from '../../components/RichContent';

export type AlreadyAppliedProps = {
  logo?: React.FC<{ className: string }>;
  content?: RichContentType;
  footer?: React.ReactNode;
};

export const AlreadyApplied = ({ content, footer, ...props }: AlreadyAppliedProps): JSX.Element => {
  const hasCustomLogo = props.logo !== undefined;
  const Logo = props.logo !== undefined ? props.logo : LogoWithText;
  const isMobile = !useBreakpoint('(min-width: 960px)');
  return (
    <div className={styles.container}>
      <WizardLayoutForm isBackHidden={true} isForwardHidden={true}>
        <SectionWithVerticalSpacing>
          {isMobile ? <Logo className={clsx(styles.logo, hasCustomLogo && styles.customLogo)} /> : null}
          <RichContentWithTooltip content={content} className={styles.body} />
          {footer}
        </SectionWithVerticalSpacing>
      </WizardLayoutForm>
    </div>
  );
};
